import type { FC } from 'react';
import type { OptionItem } from '../../../../common/types/option-item';
import { ActivitySvg } from '../../../../components/svg/activity-svg';
import { FileSvg } from '../../../../components/svg/file-svg';

export const tabList: { id: string; title: string; icon?: FC }[] = [
  { id: 'activity', title: 'Активність', icon: ActivitySvg },
  { id: 'files', title: 'Файли', icon: FileSvg }
];

export const activityTabs: OptionItem[] = [
  { id: 'activity', title: 'Активність' },
  { id: 'note', title: 'нотатки' },
  { id: 'calls', title: 'Дзвінки' },
  { id: 'meet', title: 'зустрічі' }
];
